module.exports = __webpack_public_path__ + "r-v3/img/emoti-ruined.a511aab5.svg";